import Cookies from "js-cookie";
import {
  COOKIE_NAME,
  AcceptCookieOption,
  options
} from "../../utils/cookieMessage.utils";

const cookie = Cookies.get(COOKIE_NAME);
const _ACTION_PREFIX = "frontend/CookieMessage";
export const SET_OPEN_STATE = `${_ACTION_PREFIX}/SET_OPEN_STATE`;
export const INITIALIZE = `${_ACTION_PREFIX}/SET_INIT_STATE`;
export const SET_CLOSABLE_STATE = `${_ACTION_PREFIX}/SET_CLOSABLE_STATE`;
export const TOGGLE_SETTINGS = `${_ACTION_PREFIX}/TOGGLE_SETTINGS`;
export const SET_SELECTED = `${_ACTION_PREFIX}/SET_SELECTED`;

export const initialize = ({
  isOpen,
  isClosable,
  isSettingsOpen,
  selectedCookie
}) => ({
  type: INITIALIZE,
  payload: {
    isOpen,
    isClosable,
    isSettingsOpen,
    selectedCookie
  }
});

export const toggleSettings = () => ({
  type: TOGGLE_SETTINGS,
  payload: undefined
});

export const setOpenState = isOpen => ({
  type: SET_OPEN_STATE,
  payload: isOpen
});

export const setClosableState = isClosable => ({
  type: SET_CLOSABLE_STATE,
  payload: isClosable
});

export const setSelected = selectedCookie => ({
  type: SET_SELECTED,
  payload: selectedCookie
});

export const closePopup = () => dispatch => {
  dispatch(setOpenState(false));
  dispatch(setSelected(options.filter(option => option.key === cookie)[0]));
};

export const closePopupAndSave = cookieValue => dispatch => {
  dispatch(setOpenState(false));
  dispatch(setClosableState(true));
  Cookies.set(COOKIE_NAME, cookieValue, AcceptCookieOption);
  window.location.reload();
};
